<template>
  <q-page padding>
    <div class="row col-12 align">
      <p class="text-h6 text-brand-1 text-weight-bold">
        Necessidades de Compras
      </p>
    </div>

    <div class="q-ml-md">
      <div class="row col-12 q-gutter-md q-mt-md">
        <q-btn
          label="Criar Novo Necessidade Compra"
          icon="add"
          style="border-radius: 8px; background-color: #21324a; color: white"
          no-caps
          @click="rota('compras-manual', 1)"
        />
        <q-btn
          label="Ver Produtos"
          icon="sym_o_add_box"
          style="border-radius: 8px; background-color: #304f78; color: white"
          no-caps
          @click="rota('compras-produtos', 1)"
        />
        <q-btn
          label="Criar Por Arquivo"
          icon="add"
          style="border-radius: 8px; background-color: #21324a; color: white"
          no-caps
          @click="rota('compras-upload', 1)"
        />
      </div>
      <div class="q-mt-lg">
        <div
          style="font-size: 16px"
          class="q-mb-lg text-brand-1 text-weight-medium"
        >
          <span>Utilize os campos para filtrar a lista de pedidos.</span>
        </div>
        <section class="row q-mt-md q-gutter-sm text-brand-1 text-weight-bold">
          <div class="col-md-3">
            <div class="q-ml-sm">Unidade</div>
            <lista-unidades-select v-model="unidade"></lista-unidades-select>
          </div>
          <div class="col-md-3 col-2">
            <div class="q-ml-sm">Associação de Produtos</div>
            <q-select
              :options="filtros"
              dense
              outlined
              v-model="compra"
              :rules="[(val) => val || 'Campo Obrigatório']"
            />
          </div>

          <div class="col-md col-2">
            <div class="q-ml-sm">Numero da Necessidade</div>
            <q-input outlined dense v-model="numero"> </q-input>
          </div>

          <div class="col-md col-2">
            <div class="q-ml-sm">Nome do Reponsável</div>
            <q-input outlined dense v-model="responsavel"> </q-input>
          </div>
        </section>
      </div>
    </div>

    <div>
      <q-table
        flat
        :rows="rows"
        :columns="columns"
        table-header-style="background-color: #d9effc"
        :loading="disable"
        dense
        class="tabela-tamanho-fixo"
        hide-pagination
        v-model:pagination="pagination"
        :rows-per-page-options="[0]"
        title-class="text-brand-5 text-weight-bold"
        @request="handleRequest"
      >
        <template #body-cell-solicitante_nome="props">
          <q-td class="text-brand-5 text-weight-bold">
            <div class="row">
              <span>
                {{ props.row.solicitante_nome }}
              </span>
              <span> ( {{ props.row.solicitante_matricula }}) </span>
            </div>
          </q-td>
        </template>
        <template #body-cell-cost_center_code="props">
          <q-td class="text-brand-5 text-weight-bold">
            <div class="row">
              <span class="row">
                {{ props.row.cost_center_code }}
              </span>
              <span class="row"> ({{ props.row.cost_center_name }}) </span>
            </div>
          </q-td>
        </template>
        <template #body-cell-numero="props">
          <q-td class="text-brand-5 text-weight-bold">
            {{ props.row.numero }}
          </q-td>
        </template>
        <template #body-cell-usuario_nome="props">
          <q-td class="text-brand-5 text-weight-bold">
            {{ props.row.usuario_nome }}
          </q-td>
        </template>
        <template #body-cell-tag="props">
          <q-td class="text-brand-5 text-weight-bold">
            {{ props.row.tag }}
          </q-td>
        </template>
        <template #body-cell-created_at="props">
          <q-td class="text-brand-5 text-weight-bold">
            <span class="row col-12">
              {{
                props.row.created_at
                  .split(" ")[0]
                  .split("-")
                  .reverse()
                  .join("/")
              }}
            </span>
            <span>{{ props.row.created_at.split(" ")[1] }}</span>
          </q-td>
        </template>
        <template #body-cell-total_produtos_pedidos="props">
          <q-td class="text-brand-5 text-weight-bold">
            {{ props.row.total_produtos_pedidos }}
          </q-td>
        </template>
        <template #body-cell-porcentagem="props">
          <q-td class="text-brand-5 text-weight-bold">
            {{
              props.row.total_produtos_pedidos == 0 &&
              props.row.total_produtos == 0
                ? "0%"
                : (
                    (props.row.total_produtos_pedidos /
                      props.row.total_produtos) *
                    100
                  ).toFixed(1) + "%"
            }}
          </q-td>
        </template>
        <template #body-cell-acompanhar="props">
          <q-td>
            <q-btn
              @click="rota('compras-acompanhar', props.row.uuid)"
              round
              flat
              color="primary"
              icon="sym_o_visibility"
            />
          </q-td>
        </template>
        <template #body-cell-deletar="props">
          <q-td>
            <q-btn
              @click="confirmarDeletar(props.row.uuid)"
              icon="sym_o_delete"
              round
              flat
              color="negative"
            />
          </q-td>
        </template>
        <template #body-cell-imprimir="props">
          <q-td>
            <q-btn
              icon="sym_o_print"
              flat
              round
              color="black"
              target="_blank"
              :to="{
                name: 'compras-imprimir',
                params: {
                  id: props.row.uuid,
                },
              }"
            />
          </q-td>
        </template>
        <template #body-cell-imprimir2="props">
          <q-td>
            <q-btn
              icon="sym_o_print"
              flat
              round
              color="brand-2"
              target="_blank"
              :to="{
                name: 'compras-form-sup',
                params: {
                  id: props.row.uuid,
                },
              }"
            />
          </q-td>
        </template>

        <template #body-cell-total_produtos="props">
          <q-td class="text-brand-5 text-weight-bold">
            <div class="row">
              <span>{{
                props.row.total_itens_sem_codigo + props.row.total_produtos
              }}</span>
              <span v-if="props.row.total_itens_sem_codigo != 0"
                >({{ props.row.total_itens_sem_codigo }})</span
              >
            </div>
          </q-td>
        </template>

        <template #body-cell-detalhe="props">
          <q-td>
            <q-btn
              @click="rota('compras-detalhe', props.row.uuid)"
              icon="sym_o_article"
              flat
              round
              color="blue"
            />
          </q-td>
        </template>
      </q-table>
      <div class="row justify-center q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>

    <DialogConfirmDesign
      :exibir="modalDeletar"
      mensagem="Tem certeza que deseja deletar essa necessidade? Essa ação é irreversivel"
      @resultado="handleDeletarConfirmacao"
    />
  </q-page>
</template>

<script>
const columns = [
  {
    name: "numero",
    label: "Número",
    field: "numero",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "usuario_nome",
    label: "Criado por	",
    field: "usuario_nome",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "solicitante_nome",
    label: "Solicitante",
    field: "solicitante_nome",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "cost_center_code",
    label: "Unid. Cont.	",
    field: "cost_center_code",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "tag",
    label: "Urgência",
    field: (row) => (row.tag ? row.tag.toUpperCase() : ""),
    align: "left",
    style: "color: #707070; font-weight: bold",
  },

  {
    name: "created_at",
    label: "Criado em	",
    field: (row) =>
      row.created_at
        ? row.created_at.split(" ")[0].split("-").reverse().join("/")
        : "",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "total_produtos",
    label: "Total Produtos",
    field: "total_produtos",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "total_produtos_pedidos",
    label: "Produtos Comprados",
    field: "total_produtos_pedidos",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "porcentagem",
    label: "% Comprado",
    field: (row) =>
      row.total_produtos_pedidos == 0 && row.total_produtos == 0
        ? "0%"
        : ((row.total_produtos_pedidos / row.total_produtos) * 100).toFixed(1) +
          "%",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "detalhe",
    label: "Detalhe",
    field: "detalhe",
    align: "left",
  },
  {
    name: "imprimir",
    label: "Imprimir",
    field: "imprimir",
    align: "left",
  },
  {
    name: "imprimir2",
    label: "Form. Sup",
    field: "imprimir2",
    align: "left",
  },
  {
    name: "deletar",
    label: "Deletar",
    field: "deletar",
    align: "left",
  },
  {
    name: "acompanhar",
    label: "Acompanhar",
    field: "acompanhar",
    align: "left",
  },
];

import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRouter } from "vue-router";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import DialogConfirmDesign from "../../../../components/DialogConfirmDesign.vue";

export default {
  components: { ListaUnidadesSelect, DialogConfirmDesign },
  setup() {
    const router = useRouter();
    const store = useStore();
    const $q = useQuasar();
    const rows = ref([]);
    const disable = ref(true);
    const compra = ref("Todos");
    const numero = ref("");
    const unidade = ref();
    const responsavel = ref("");
    const modalDeletar = ref(false);
    const uuidParaDeletar = ref(null);

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 25,
      rowsNumber: 15,
    });

    const getDados = async (page = 1, rowsPerPage = 25) => {
      try {
        store.dispatch("pdt/hiddenHeader", true);
        const response = await store.dispatch("compras/necessidadeAssociados", {
          vendor_id: store.state.org.unidadeData.id,
          page,
          per_page: rowsPerPage,
          associado: compra.value.value,
          numero: numero.value,
          user: responsavel.value,
        });

        rows.value = response.data.data;

        pagination.value.rowsPerPage = response.data.per_page;
        pagination.value.rowsNumber = response.data.total;
        pagination.value.page = response.data.current_page;
        disable.value = false;
      } catch (error) {
        $q.notify({
          message: "Erro ao encontrar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getDados);

    const handleRequest = async () => {
      getDados(pagination.value.page, pagination.value.rowsPerPage);
    };

    const rota = async (rota, param = "") => {
      if (param != "") {
        router.push({
          name: rota,
          params: { id: param },
        });
      } else {
        router.push({
          name: rota,
        });
      }
    };

    const confirmarDeletar = (uuid) => {
      uuidParaDeletar.value = uuid;
      modalDeletar.value = true;
    };

    const handleDeletarConfirmacao = async (confirmado) => {
      modalDeletar.value = false;
      if (confirmado) {
        await deletar(uuidParaDeletar.value);
      }
      uuidParaDeletar.value = null;
    };

    const deletar = async (id) => {
      try {
        await store.dispatch("compras/deletarNecessidade", {
          uuid: id,
        });

        $q.notify({
          message: "Deletado com sucesso!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getDados();
      } catch (error) {
        $q.notify({
          message: "Erro ao deletar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => compra.value,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => numero.value,
      () => {
        getDados();
      }
    );

    watch(
      () => responsavel.value,
      () => {
        getDados();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        getDados();
      }
    );

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);

    return {
      pagination,
      rows,
      disable,
      columns,
      getDados,
      handleRequest,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      unidade,
      compra,
      rota,
      filtros: [
        {
          label: "SOMENTE ASSOCIADOS",
          value: 1,
        },
        {
          label: "SOMENTE NÃO ASSOCIADOS",
          value: 0,
        },
        {
          label: "TODOS",
          value: 2,
        },
      ],
      numero,
      deletar,
      responsavel,
      modalDeletar,
      confirmarDeletar,
      handleDeletarConfirmacao,
    };
  },
};
</script>

<style scoped>
.align {
  align-items: center;
}

.no-wrap {
  flex-wrap: nowrap !important;
}
tbody tr td {
  white-space: pre-wrap;
}
</style>
